function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

class BackToPrevious extends HTMLElement {
    constructor() {
        super();
        this.defaultUrl = this.dataset.default_url || '/';
        this.addEventListener("click", (event) => {
            event.preventDefault();
            this.backToHandle();
        });
    }

    backToHandle() {
        if (document.referrer && document.referrer !== window.location.href) {
            window.history.back();
        } else {
            window.location.href = this.defaultUrl;
        }
    }
}
customElements.define("back-to-previous", BackToPrevious);

class NewMainCart extends HTMLElement {
    constructor() {
        super();
        this.domId = "new-main-cart";
        this.sectionId = document.getElementById(this.domId).dataset.id;

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);
        this.addEventListener("change", this.debouncedOnChange.bind(this));
    }

    connectedCallback() {
        this.$cartCountDomList = document.querySelectorAll(".cart-count");
        this.$headerTotalPrice = document.querySelector("header-total-price");
        this.$cartSummaryDom = document.querySelector(".cart-summary");
        this.$cartItemsCountDom = document.querySelector(".cart-items-count");
        this.$recommendationSwiper = document.querySelector(".cart__product-recommendation");
        this.$recommendedAddons = document.querySelector(".cart-recommended-addons");
    }

    onChange(event) {
        let value = event.target.value;
        if (!value || isNaN(value) || value < 0) {
            value = 0;
        }else{
            value = parseInt(value, 10);
        }
        this.updateQuantity(
            event.target.dataset.index,
            value,
            event.target
        );
    }

    updateQuantity(line, quantity, target) {
        const removeBtn = this.querySelector(`cart-remove-button[data-index="${line}"]`);
        removeBtn?.classList.add("loading");

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(
            `${routes.cart_change_url}`, 
            { ...fetchConfig(), ...{ body } }
        ).then((response) => {
            return response.text();
        }).then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
                this.updateMessageErrors(line, parsedState.errors, target);
                this.disableLoading();
                return;
            }
            this.renderData(parsedState, quantity);
        }).catch((e) => {
            console.error(e);
            this.disableLoading();
        }).finally(() => {
            removeBtn?.classList.remove("loading");
        });
    }

    renderData(parsedState, quantity) {
        if(parsedState.item_count === undefined) {
            fetch("/cart.json")
            .then((res) => res.json())
            .then((cart) => {
                parsedState.item_count = cart.item_count;
                this.updateItemsCount(parsedState, quantity);
            }).catch((error) => {
                console.error('Error fetching cart:', error);
                this.updateItemsCount(parsedState, quantity);
            });
        }else {
            this.updateItemsCount(parsedState, quantity);
        }
    }

    updateItemsCount(parsedState, quantity) {
        if (parsedState.item_count != undefined) {
            this.$cartCountDomList.forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                    el.innerHTML = `(${parsedState.item_count})`;
                } else {
                    el.innerHTML = parsedState.item_count > 100 ? "~" : parsedState.item_count;
                }
            });
            if (this.$headerTotalPrice) {
                this.$headerTotalPrice.updateTotal(parsedState);
            }
        }
        if (parsedState.item_count == 0) {
            this.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.querySelector('.cart-body');
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    `.cart-body`
                );
            });
        } else {
            setTimeout(() => {
                if (quantity > 0) {
                    this.toastSuccess(window.variantStrings.addSuccess);
                } else {
                    this.toastSuccess(window.variantStrings.removeCartItem);
                }
            }, 20);
            this.updateCartUI(parsedState);
        }
        this.disableLoading();
    }

    updateCartUI(data) {
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);
            if (!sectionElement) return;

            const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
            if (elementToReplace) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    data.sections[section.section],
                    section.selector
                );
            }
        });
        if(this.$cartSummaryDom || this.$cartItemsCountDom || this.$recommendationSwiper) {
            const sectionDoc = new DOMParser().parseFromString(data.sections[this.sectionId], "text/html");
            if(this.$cartSummaryDom) {
                const el = sectionDoc.querySelector(".cart-summary");
                this.$cartSummaryDom.innerHTML = el ? el.innerHTML : '';
            }
            if(this.$cartItemsCountDom) {
                const el = sectionDoc.querySelector(".cart-items-count");
                this.$cartItemsCountDom.innerHTML = el ? el.innerHTML : '';
            }
            if(this.$recommendationSwiper) {
                const el = sectionDoc.querySelector(".cart__product-recommendation");
                this.$recommendationSwiper.innerHTML = el ? el.innerHTML : '';
            }
        }
        const $addonsContainer = document.querySelector('.cart-recommended-addons');
        if($addonsContainer) {
            const newAddonsHtml = this.getSectionInnerHTML(
                data.sections[this.sectionId],
                ".cart-recommended-addons"
            );
            if(newAddonsHtml) {
                $addonsContainer.innerHTML = newAddonsHtml;
            } else {
                $addonsContainer.remove();
            }
        }
        BlsLazyloadImg.init();
    }

    getSectionsToRender() {
        return [
            {
                id: this.domId,
                section: this.sectionId,
                selector: ".cart-item-list"
            }
        ];
    }

    getSectionInnerHTML(html, selector) {
        const el = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
        return el ? el.innerHTML : '';
    }

    updateMessageErrors(line, message, target) {
        const val = target.dataset.value || target.value;
        target.value = val;
        this.toastError(message, line);
    }

    toastSuccess(message) {
        const wrapperDiv = document.createElement("div");
        wrapperDiv.innerHTML = `
            <div class="mt-10 newsletter-form__message--success success form__message inline-flex align-center" tabindex="-1">
                <svg width="18" height="18" fill="none">
                    <g stroke="#137F24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                        <path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>
                    </g>
                </svg>
                <span class="ml-5">${message}</span>
            </div>
        `;
        showToast(wrapperDiv.innerHTML, 2000, "modal-success");
    }

    toastError(message, line) {
        var wrapperDiv = document.createElement("div");
        wrapperDiv.innerHTML = `
            <div class="mt-10 line-item-error-${line || 1} error form__message inline-flex align-center" tabindex="-1">
                <svg width="18" height="18" fill="none" class="flex-auto">
                    <g stroke="#D0473E" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                        <path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>
                    </g>
                </svg>
                <span class="ml-5">${message}</span>
            </div>
        `;
        showToast(wrapperDiv.innerHTML, 2000, "modal-error");
    }

    disableLoading() {}
}
customElements.define("new-main-cart", NewMainCart);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.cart = this.closest("new-main-cart") || document.querySelector("new-main-cart");
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const index = this.dataset.index;
            if(this.cart && index != undefined) {
                this.cart.updateQuantity(index, 0);
            }
        });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartDiscount extends HTMLElement {
    /** @type {AbortController | null} */
    #activeFetch = null;

    constructor() {
        super();
        this.form = null;
        this.submitButton = null;
        this.codeInput = null;
        this.cart = null;
        this.discountPills = null;
        this.init();
    }

    init() {
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.codeInput = this.querySelector('input[name="discount"]');
        this.cart = document.querySelector("new-main-cart");
        this.discountPills = this.querySelectorAll(".cart-discount__item, [data-discount-code]");

        if(this.form) this.form.addEventListener("submit", this.applyDiscount);
        this.addEventListener("click", (event) => {
            if (event.target.closest(".cart-discount-remove")) {
                this.removeDiscount(event);
            }
        });
    }

    #createAbortController() {
        if (this.#activeFetch) {
            this.#activeFetch.abort();
        }

        const abortController = new AbortController();
        this.#activeFetch = abortController;
        return abortController;
    }

    /**
     * Common method to update cart with discount changes
     * @param {string[]} discountCodes - Array of discount codes
     * @param {AbortController} abortController - Abort controller for the request
     * @returns {Promise<Object>} - Cart update response
     */
    async #updateCartDiscount(discountCodes, abortController) {
        const body = JSON.stringify({
            discount: discountCodes.join(","),
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: body,
            signal: abortController.signal,
        });

        return response.json();
    }

    /**
     * Common method to update UI after cart changes
     * @param {Object} data - Cart response data
     */
    #updateCartUI(data) {
        if(this.cart) {
            this.cart.updateCartUI(data);
            return
        }
    }

    /**
     * Common method to handle loading states
     * @param {boolean} isLoading - Loading state
     */
    #setLoadingState(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
            this.submitButton.setAttribute("aria-disabled", "true");
            this.submitButton.classList.add("loading");
        } else {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
        }
    }

    /**
     * Common error handling method
     * @param {Error} error - Error object
     * @param {string} operation - Operation that failed
     */
    #handleError(error, operation = "discount operation") {
        if (error.name !== "AbortError") {
            console.error(`Error during ${operation}:`, error);
            this.#handleDiscountError();
        }
    }

    /**
     * Handles updates to the cart discount.
     * @param {SubmitEvent} event - The submit event on our form.
     */
    applyDiscount = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.codeInput) {
            console.warn("CartDiscount: No discount input found");
            return;
        }

        const discountCodeValue = this.codeInput.value.trim();
        if (!discountCodeValue) return;

        // Check if discount already exists
        const existingDiscounts = this.#existingDiscounts();
        if (existingDiscounts.includes(discountCodeValue)) {
            this.toastError(cartStrings?.discount_already);
            return;
        }

        this.#setLoadingState(true);
        const abortController = this.#createAbortController();

        try {
            const updatedDiscounts = [...existingDiscounts, discountCodeValue];
            const data = await this.#updateCartDiscount(
                updatedDiscounts,
                abortController
            );

            if (data.discount_codes.find((discount) => discount.code === discountCodeValue && !discount.applicable)) {
                this.#handleDiscountError();
                return;
            }

            this.codeInput.value = "";
            this.#updateCartUI(data);
            this.toastSuccess(cartStrings?.discount_applied);
        } catch (error) {
            this.#handleError(error, "applying discount");
        } finally {
            this.#setLoadingState(false);
            this.#activeFetch = null;
        }
    };

    /**
     * Handles removing a discount from the cart.
     * @param {MouseEvent | KeyboardEvent} event - The mouse or keyboard event in our pill.
     */
    removeDiscount = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const removeButton = event.target.closest(".cart-discount-remove");
        removeButton.setAttribute("aria-disabled", "true");
        removeButton.classList.add("loading");

        if (event instanceof KeyboardEvent && event.key !== "Enter") {
            return;
        }

        const discountCode = this.#getDiscountCodeFromEvent(event);
        if (!discountCode) return;

        const existingDiscounts = this.#existingDiscounts();
        const updatedDiscounts = existingDiscounts.filter(
            (code) => code !== discountCode
        );

        if (updatedDiscounts.length === existingDiscounts.length) {
            console.warn("Discount code not found in existing discounts");
            return;
        }

        const abortController = this.#createAbortController();

        try {
            const data = await this.#updateCartDiscount(
                updatedDiscounts,
                abortController
            );
            this.#updateCartUI(data);
            this.toastSuccess(cartStrings?.discount_removed);
        } catch (error) {
            this.#handleError(error, "removing discount");
        } finally {
            this.#activeFetch = null;
            removeButton.setAttribute("aria-disabled", "false");
            removeButton.classList.remove("loading");
        }
    };

    /**
     * Extract discount code from remove event
     * @param {Event} event - Click/keyboard event
     * @returns {string|null} - Discount code or null
     */
    #getDiscountCodeFromEvent(event) {
        const removeButton = event.target.closest(".cart-discount__item");
        return removeButton ? removeButton.dataset.discountCode : null
    }

    /**
     * Handles the discount error.
     */
    #handleDiscountError() {
        this.toastError(cartStrings?.discount_error);
    }

    /**
     * Returns an array of existing discount codes.
     * @returns {string[]}
     */
    #existingDiscounts() {
        return Array.from(this.discountPills)
            .map(pill => pill.dataset.discountCode?.trim())
            .filter(Boolean);
    }

    getSectionsToRender() {
        if (!this.cart) {
            console.warn('CartDiscount: No element found with id="new-main-cart"');
            return [];
        }

        return [
            {
                id: this.cart.domId,
                section: this.cart.sectionId,
                selector: ".cart-item-list"
            }
        ]
    }

    getSectionInnerHTML(html, selector) {
        return (
            new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || ""
        );
    }

    toastSuccess(message) {
        const toast = this.#createToast(message, "success");
        showToast(toast, 2000, "modal-success");
    }

    toastError(message) {
        const toast = this.#createToast(message, "error");
        showToast(toast, 2000, "modal-error");
    }

    /**
     * Create toast message HTML
     * @param {string} message - Toast message
     * @param {string} type - Toast type (success/error)
     * @returns {string} - Toast HTML
     */
    #createToast(message, type) {
        const isSuccess = type === "success";
        const iconColor = isSuccess ? "#137F24" : "#D0473E";
        const className = isSuccess
            ? "newsletter-form__message--success success"
            : "line-item-error-1 error";

        const iconPath = isSuccess
            ? `<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>`
            : `<path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>`;

        return `
            <div class="mt-10 ${className} form__message inline-flex align-center" tabindex="-1">
                <svg width="18" height="18" fill="none" class="flex-auto">
                <g stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                    ${iconPath}
                </g>
                </svg>
                <span class="ml-5">${message}</span>
            </div>
        `;
    }
}
if (!customElements.get("cart-discount")) {
    customElements.define("cart-discount", CartDiscount);
}

class CartNote extends HTMLElement {
    constructor() {
        super();
        this.$title = this.querySelector('.cart-note_title');
        this.$textarea = this.querySelector('[name="note"]');

        this.$title.addEventListener('click', () => {
            this.classList.add('open');
        })
        this.$textarea.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                ...{ body },
            });
        }, 300))
    }
}
if (!customElements.get("cart-note")) {
    customElements.define("cart-note", CartNote);
}

class CartEditButton extends HTMLElement {
    constructor() {
        super();
        this.$popup = document.getElementById('ai-plan-recommendation');
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const handle = this.closest(".cart-item")?.dataset.handle || '';
            
            if(this.$popup && handle) {
                this.$popup.open(handle);
            }
        });
    }
}
customElements.define("cart-edit-button", CartEditButton);

class CartAddButton extends HTMLElement {
    constructor() {
        super();
        this.$popup = document.getElementById('ai-plan-recommendation');
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const $cartItem = this.closest(".cart-item");
            const handle = $cartItem?.dataset.handle || this.dataset.handle || '';

            if(this.$popup && handle) {
                this.$popup.open(handle);
            }
        });
    }
}
customElements.define("cart-add-button", CartAddButton);

class CartProuductRecommendation extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.upsellUrl = this.dataset.url || '';
        this.$swiper = this.querySelector(".swiper") || '';
        this.$swiperWrapper = this.querySelector(".swiper-wrapper") || '';
        this.$prevEl = this.querySelector(".swiper-button-prev") || '';
        this.$nextEl = this.querySelector(".swiper-button-next") || '';

        this.init();
    }

    init() {
        this.upsellUrl = this.dataset.url || '';
        if(this.upsellUrl) {
            fetch(this.upsellUrl).then(
                (response) => response.text()
            ).then((text) => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(".swiper-wrapper");
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.$swiperWrapper.innerHTML = recommendations.innerHTML;
                }
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                this.initSwiper();
            })
        }else {
            this.initSwiper();
        }
    }

    initSwiper() {
        this.swiper = new Swiper(this.$swiper, {
            grabCursor: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            navigation: {
                prevEl: this.$prevEl,
                nextEl: this.$nextEl
            }
        }); 
    }
}
customElements.define("cart-prouduct-recommendation", CartProuductRecommendation);

class CartTrustBarSwiper extends HTMLElement {
    constructor() {
        super();
        this.mql = window.matchMedia("(max-width: 768px)");
        this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
        this.wrapper = this.querySelector(".cart-trust-bar__inner");
        this.items = this.querySelectorAll(".cart-trust-item");
        this.separators = this.querySelectorAll(".cart-trust-separator");
        this.handleChange(this.mql);
        this.mql.addEventListener("change", this.handleChange);
    }

    disconnectedCallback() {
        this.mql.removeEventListener("change", this.handleChange);
        this.destroySwiper();
    }

    handleChange(e) {
        e.matches ? this.initSwiper() : this.destroySwiper();
    }

    initSwiper() {
        if (this.swiper) return;
        this.classList.add("swiper");
        this.wrapper.classList.add("swiper-wrapper");
        this.wrapper.classList.remove("flex", "justify-between", "gap-custom");
        this.items.forEach(el => {
            el.classList.add("swiper-slide");
            el.classList.remove("flex-1");
        });
        this.separators.forEach(el => el.classList.add("hidden"));
        const delaySec = parseFloat(this.dataset.autoplayDelay) || 3;
        this.swiper = new Swiper(this, {
            loop: true,
            autoplay: { delay: delaySec * 1000, disableOnInteraction: false },
            slidesPerView: 1
        });
    }

    destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
        this.classList.remove("swiper");
        this.wrapper.classList.remove("swiper-wrapper");
        this.wrapper.classList.add("flex", "justify-between", "gap-custom");
        this.items.forEach(el => {
            el.classList.remove("swiper-slide");
            el.classList.add("flex-1");
        });
        this.separators.forEach(el => el.classList.remove("hidden"));
    }
}
customElements.define("cart-trust-bar-swiper", CartTrustBarSwiper);

class TTProductItem extends HTMLElement {
    constructor() {
        super();

        this.$cart = document.querySelector("new-main-cart");
        this.$cartCountDomList = document.querySelectorAll(".cart-count");
        this.$headerTotalPrice = document.querySelector("header-total-price");
        this.$imgList = this.querySelectorAll(".product-img");
        this.$price = this.querySelector(".price.price--highlight");
        this.$comparePrice = this.querySelector(".price.price--compare");
        this.$variantSelect = this.querySelector("select.variant-select");
        this.$sellingPlanInput = this.querySelector(`[name="selling_plan"]`);
        this.$addCartBtn = this.querySelector(".add-cart-btn");
        this.$addCartBtnText = this.$addCartBtn?.querySelector(".loader-button__text") || this.$addCartBtn?.querySelector(".hidden-on-load");

        this.addCartText = this.$addCartBtn?.dataset.btnAdd_to_cart || '';
        this.soldOutText = this.$addCartBtn?.dataset.btnSold_out || '';

        this.querySelectorAll(".option-item").forEach(item => {
            item.addEventListener("click", () => {
                this.changeOption(item);
            });
        });
        this.$addCartBtn?.addEventListener("click", (e) => {
            e.preventDefault();
            this.addToCart();
        });
    }

    changeOption(item) {
        const value = item.dataset.value || '';
        const position = parseInt(item.parentElement.dataset.position || '', 10);
        const $activeImg = this.querySelector(".product-img.active");
        if(!$activeImg || !value || !position) return;

        let options = ($activeImg.dataset.title || '').split(" / ");
        options[position - 1] = value;
        const newTitle = options.join(" / ");

        const $newImg = Array.from(this.$imgList).find(el => el.dataset.title === newTitle);
        if (!$newImg) return

        const id = $newImg.dataset.id || '';
        const available = $newImg.dataset.available === 'true';
        const price = $newImg.dataset.price || '';
        const compare_price = $newImg.dataset.compare_price || '';
        const selling_plan_id = $newImg.dataset.selling_plan || '';

        if(this.$price) this.$price.textContent = price;
        if(this.$comparePrice) this.$comparePrice.textContent = compare_price;
        $activeImg.classList.remove("active");
        $newImg.classList.add("active");
        const $activeOption = item.parentElement.querySelector(".option-item.active");
        if($activeOption) $activeOption.classList.remove("active");
        item.classList.add("active");
        const $optionTitle = item.closest('.product-variant-option')?.querySelector('.product-option-title span');
        if ($optionTitle) $optionTitle.textContent = value;

        if(this.$variantSelect) {
            this.$variantSelect.value = id;
            this.$variantSelect.dispatchEvent(new Event("change"));
        }
        if(this.$sellingPlanInput) {
            this.$sellingPlanInput.value = selling_plan_id;
        }
        if (this.$addCartBtn) {
            this.$addCartBtn.disabled = !available;
            if(this.$addCartBtnText){
                this.$addCartBtnText.textContent = available ? this.addCartText : this.soldOutText;
            }
        }
    }

    addToCart() {
        const id = String(this.$variantSelect.value) || '';
        const selling_plan_id = String(this.$sellingPlanInput.value) || '';
        if(!this.$cart || !id) return;

        this.$addCartBtn?.classList.add('loading');
        const body = JSON.stringify({
            id,
            quantity: 1,
            selling_plan: selling_plan_id || undefined,
            sections: this.$cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        // ga4 添加购物车推送，需要拿实时的form数据所以需要在这里获取
        const form = this.querySelector("form[data-type='add-to-cart-form']");
        if (form && typeof handleAddToCart === "function") {
            handleAddToCart(form);
        }

        let preTask = Promise.resolve();
        if (selling_plan_id) {
            preTask = fetch('/cart.json')
            .then(res => res.json())
            .then(cart => {
                const itemsToRemove = cart.items.filter(item => item.selling_plan_allocation && String(item.id) !== id);
                if (itemsToRemove.length > 0) {
                    const updates = {};
                    itemsToRemove.forEach(item => {
                        updates[item.id] = 0;
                    });
                    return fetch("/cart/update.js", {
                        ...fetchConfig(),
                        body: JSON.stringify({ updates })
                    });
                }
            })
            .catch(e => console.error(e));
        }

        preTask.then(() => fetch(routes.cart_add_url, { 
            ...fetchConfig(), 
            ...{ body } 
        })).then((response) => {
            return response.text();
        }).then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
                this.$cart.updateMessageErrors(this.$addCartBtn.dataset.index, parsedState.errors, this.$addCartBtn);
                this.$cart.disableLoading();
                return;
            }
            this.$cart?.renderData(parsedState, 1);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            this.$addCartBtn?.classList.remove('loading');
            window.scrollTo({top: 0,behavior: 'smooth'});
        });
    }
}
customElements.define("tt-product-item", TTProductItem);

class CartRecommendedAddons extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', (e) => {
            const toggle = e.target.closest('.cart-recommended-addons__toggle');
            if (!toggle) return;
            const expanded = this.dataset.expanded !== 'true';
            this.dataset.expanded = expanded;
            toggle.setAttribute('aria-expanded', expanded);
            const { moreText, lessText, moreTextMobile, lessTextMobile } = toggle.dataset;
            const desktopLabel = toggle.querySelector('.hidein__mobile');
            const mobileLabel = toggle.querySelector('.hidein__pc');
            if (desktopLabel) desktopLabel.textContent = expanded ? lessText : moreText;
            if (mobileLabel) mobileLabel.textContent = expanded ? lessTextMobile : moreTextMobile;
        });
    }
}
customElements.define("cart-recommended-addons", CartRecommendedAddons);